"use client";
import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRouter } from "next/navigation";
import { useTransitionRouter } from "next-transition-router";

gsap.registerPlugin(ScrollTrigger);

interface NavbarProps {
  children?: React.ReactNode;
}

const Navbar: React.FC<NavbarProps> = ({ children }) => {
  const router = useTransitionRouter();
  useEffect(() => {
    // animasi progress bar saat scroll
    gsap.to(".progress-bar", {
      width: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: document.body,
        start: "top top",
        end: "bottom bottom",
        scrub: true
      }
    });
  }, []);

  return (
    <main className='w-full flex flex-col relative bg-beige-200'>
      {/* Header Navbar */}
      <header className='sticky top-0  backdrop-blur-xl backdrop-brightness-50 bg-beige-200/40 backdrop:invert-100 text-white z-50'>
        <div className='flex items-center w-full h-full  justify-between px-10  '>
          <div className=' font-surgena size-10 bg-neutral-900 rounded-full p-2'>
            <img src={"/icons/HUCO-48x48.png"} onClick={() => router.push("/")} className='invert-100'></img>
          </div>
          <nav className='flex  text-xs uppercase   2xl:text-4xl  items-center gap-2 '>
            <div
              onClick={() => {
                const element = document.getElementById("gallery");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className='hover:opacity-70 cursor-pointer pointer-events-auto z-90 items-center w-full gap-5  md:min-w-[15rem] text-beige-900  py-5  relative flex overflow-hidden    '
            >
              <span className='rounded-full  size-3 border-2 border-beige-200 inline-block font-extrabold'></span>
              gallery
            </div>
            <div
              onClick={() => {
                const element = document.getElementById("contact");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className='hover:opacity-70 cursor-pointer pointer-events-auto z-90 items-center w-full gap-5  md:min-w-[15rem] text-beige-900  py-5  relative flex overflow-hidden    '
            >
              <span className='rounded-full size-3 border-2 border-beige-200 inline-block'></span>
              Contact
            </div>
          </nav>
        </div>

        {/* Scroll progress line */}
        <div className='h-[1.5px]  bg-transparent w-full relative  '>
          <div className='progress-bar absolute top-0 z-40 left-0 h-full bg-beige-900 w-0'></div>
        </div>
      </header>
      {/* Konten anak di bawah navbar */}
      <main>{children}</main>
    </main>
  );
};

export default Navbar;
